import { Box, Grid } from '@mui/material';
import { 
	BooleanInput, 
	Edit, 
	DateInput, 
	NumberInput, 
	ReferenceInput, 
	SelectInput, 
	SimpleForm, 
	TextInput 
} from 'react-admin';

const DatingEventCouponEdit = () => (
	<Edit resource="dating-event-coupon">
		<SimpleForm>
			<Grid spacing={2} container>
				<Grid item sm={6}>
					<TextInput source="code" fullWidth label="קוד קופון" dir="ltr" required />
				</Grid>
				<Grid item sm={6}>
					<ReferenceInput source="datingEvent" reference="dating-events" label="אירוע דייטינג" required>
						<SelectInput optionText="title" optionValue="_id" />
					</ReferenceInput>
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<NumberInput source="discount_percentage" fullWidth label="אחוז הנחה" min={0} max={100} required />
				</Grid>
				<Grid item sm={6}>
					<NumberInput source="max_uses" fullWidth label="שימושים מקסימליים" min={1} required />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<DateInput source="valid_from" fullWidth label="תקף מ" required />
				</Grid>
				<Grid item sm={6}>
					<DateInput source="valid_until" fullWidth label="תקף עד" required />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<TextInput source="description" fullWidth label="תיאור" multiline dir="rtl" />
				</Grid>
				<Grid item sm={6}>
					<BooleanInput source="is_active" fullWidth label="פעיל" />
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<NumberInput source="used_count" fullWidth label="שימושים נוכחיים" disabled />
				</Grid>
				<Grid item sm={6}>
					<TextInput source="createdAt" fullWidth label="נוצר בתאריך" disabled />
				</Grid>
			</Grid>
		</SimpleForm>
	</Edit>
);

export default DatingEventCouponEdit;
